(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exp-custom-blog-detail"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const currentUrl = window.location.href;

    // Fix SilverStripe Image Shortcodes inside blog content
    const blogContent = document.querySelector('.html-content');
    if (blogContent) {
      blogContent.innerHTML = blogContent.innerHTML.replace(/\[image\s+([^\]]+)\]/g, (match, attrsInfo) => {
        const getAttr = (name) => {
          const result = attrsInfo.match(new RegExp(name + '="([^"]*)"'));
          return result ? result[1] : '';
        };

        let src = getAttr('src');
        const id = getAttr('id');
        const w = getAttr('width');
        const h = getAttr('height');
        const cls = getAttr('class');

        // Fix Src URL per user request
        if (src && src.includes('/assets/Artikel/')) {
          // Remove the hash folder: /assets/Artikel/HASH/file.jpg -> https://vapeboss.co.id/assets/Artikel/file.jpg
          const filename = src.substring(src.lastIndexOf('/') + 1);
          src = `https://vapeboss.co.id/assets/Artikel/${filename}`;
        }

        return `<img src="${src}" id="${id}" width="${w}" height="${h}" class="${cls}" loading="lazy" />`;
      });

      // Fix Link URL migration (Legacy to Shopify)
      // Example: https://vapeboss.co.id/all-news/news-read/read/handle -> /blogs/news/handle
      // Example: https://vapeboss.co.id/products/view/handle -> /products/handle
      const links = blogContent.querySelectorAll('a');
      links.forEach((link) => {
        const href = link.getAttribute('href');
        if (href) {
          if (href.includes('/all-news/news-read/read/')) {
            const parts = href.split('/all-news/news-read/read/');
            if (parts.length > 1) {
              const handle = parts[1];
              link.href = `/blogs/news/${handle}`;
            }
          } else if (href.includes('/products/view/')) {
            const parts = href.split('/products/view/');
            if (parts.length > 1) {
              const handle = parts[1];
              link.href = `/products/${handle}`;
            }
          }
        }
      });
    }

    // Facebook Share
    document.querySelectorAll('.js-share-facebook').forEach((btn) => {
      btn.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(currentUrl);
    });

    // Twitter Share
    document.querySelectorAll('.js-share-twitter').forEach((btn) => {
      btn.href =
        'https://twitter.com/intent/tweet?url=' +
        encodeURIComponent(currentUrl) +
        '&text=Kunjungi%20VapeBoss%20Disini%20Sekarang%21';
    });

    // Copy Link
    document.querySelectorAll('.js-share-copy').forEach((btn) => {
      btn.addEventListener('click', () => {
        navigator.clipboard
          .writeText(currentUrl)
          .then(() => {
            alert('URL berhasil disalin!');
          })
          .catch((error) => {
            console.error('Gagal menyalin URL:', error);
          });
      });
    });

    // Style "Baca Juga" paragraphs and standalone links inside content
    const contentContainer = document.querySelector('.html-content');
    if (contentContainer) {
      const paragraphs = contentContainer.querySelectorAll('p');
      paragraphs.forEach((p) => {
        const text = p.innerText.trim();
        const link = p.querySelector('a');

        // Check if it's a "Baca Juga" paragraph OR a standalone link (potentially bold)
        // Standalone link check: P contains a link, and the text content is roughly the same length (allowing for some whitespace/punctuation)
        const isBacaJuga = text.toLowerCase().startsWith('baca juga') || text.toLowerCase().startsWith('baca juga:');
        const isStandaloneLink = link && text.length <= link.innerText.length + 5;

        if (isBacaJuga) {
          // Add Tailwind classes for the blue border and padding styling
          p.classList.add(
            'tw:border-l-4!',
            'tw:border-blue-700!',
            'tw:pl-4!',
            'tw:py-3!',
            'tw:font-bold!',
            'tw:my-3!',
            'tw:bg-gray-50!'
          );

          if (link) {
            // Style the link specifically if needed
            link.classList.add('tw:text-blue-700!', 'tw:underline!');
          }
        } else if (isStandaloneLink) {
          p.classList.add(
            'tw:border-l-4!',
            'tw:border-blue-700!',
            'tw:pl-4!',
            'tw:py-3!',
            'tw:font-bold!',
            'tw:bg-gray-50!'
          );
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["exp-custom-blog-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('blog-search-input');
    const clearBtn = document.getElementById('blog-search-clear');
    const statusContainer = document.getElementById('search-status-container');
    const defaultView = document.getElementById('blog-default-view');
    const searchView = document.getElementById('blog-search-view');
    const searchItems = document.querySelectorAll('.js-search-item');
    const paginationWrapper = document.getElementById('pagination-wrapper');

    function performSearch() {
      const query = searchInput.value.toLowerCase().trim();
      let matchCount = 0;

      if (query.length > 0) {
        // Show search UI
        clearBtn.classList.remove('tw:hidden!');
        defaultView.classList.add('tw:hidden!');
        if (paginationWrapper) paginationWrapper.classList.add('tw:hidden!');
        searchView.classList.remove('tw:hidden!');

        // Split query into individual keywords for comprehensive matching
        const keywords = query.split(/\s+/).filter(Boolean);

        searchItems.forEach((item) => {
          const title   = (item.getAttribute('data-title')   || '').toLowerCase();
          const tags    = (item.getAttribute('data-tags')    || '').toLowerCase();
          const content = (item.getAttribute('data-content') || '').toLowerCase();
          const author  = (item.getAttribute('data-author')  || '').toLowerCase();
          const haystack = `${title} ${tags} ${content} ${author}`;

          // Article matches if ALL keywords are found somewhere in the haystack
          const matches = keywords.every((kw) => haystack.includes(kw));
          if (matches) {
            item.classList.remove('tw:hidden!');
            matchCount++;
          } else {
            item.classList.add('tw:hidden!');
          }
        });

        statusContainer.classList.remove('tw:hidden!');
        if (matchCount > 0) {
          statusContainer.innerHTML = `<div class="tw:bg-black! tw:text-white! tw:py-3! tw:px-6! tw:rounded-full! tw:inline-block! tw:border! tw:border-black!">Ditemukan ${matchCount} artikel untuk "${searchInput.value}"</div>`;
        } else {
          statusContainer.innerHTML = `
          <h3 class="tw:text-2xl! tw:font-semibold! tw:text-gray-800! tw:mb-2!">Tidak ditemukan artikel yang sesuai dengan pencarian "${searchInput.value}"</h3>
          <p class="tw:text-gray-500!">Coba sesuaikan kata kunci atau <a href="#" id="reset-search-link" class="tw:text-black! tw:underline!">lihat semua artikel</a>.</p>
         `;
          document.getElementById('reset-search-link').addEventListener('click', (e) => {
            e.preventDefault();
            searchInput.value = '';
            performSearch();
          });
        }
      } else {
        // Reset to default UI
        clearBtn.classList.add('tw:hidden!');
        statusContainer.classList.add('tw:hidden!');
        searchView.classList.add('tw:hidden!');

        defaultView.classList.remove('tw:hidden!');
        if (paginationWrapper) paginationWrapper.classList.remove('tw:hidden!');

        // Reset items visibility for next time
        searchItems.forEach((item) => {
          item.classList.remove('tw:hidden!');
        });
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', performSearch);

      // Allow pressing Enter to trigger search
      searchInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') performSearch();
      });

      // Search button click
      const searchBtn = document.getElementById('blog-search-btn');
      if (searchBtn) searchBtn.addEventListener('click', performSearch);

      clearBtn.addEventListener('click', () => {
        searchInput.value = '';
        performSearch();
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
